import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatRelativeTime } from '../../lib/dashboard/relativeTime';
import { playlistPath } from '../playlists/playlistRoutes';
import type { HomePlaylistCard } from './buildHomePlaylistCards';
import { HomePlaylistPreview } from './HomePlaylistPreview';
import { HomeRailPanel } from './HomeRailPanel';

type HomeRecentRailProps = {
  recent: HomePlaylistCard[];
};

export function HomeRecentRail({ recent }: HomeRecentRailProps) {
  const { t } = useTranslation('home');
  return (
    <HomeRailPanel title={t('recent.title')} link={{ label: t('recent.viewAll'), to: '/playlists' }}>
      {recent.length === 0 ? (
        <p className="m-0 text-sm" style={{ color: 'var(--gs-muted)' }}>
          {t('recent.empty')}
        </p>
      ) : (
        recent.map((item) => (
          <Link
            key={item.id}
            to={playlistPath(item.id)}
            className="flex items-center gap-3 transition hover:opacity-90"
            style={{ color: 'var(--gs-ink)' }}
          >
            <HomePlaylistPreview
              previews={item.previews.slice(0, 1)}
              compact
              className="h-[42px] w-[58px] shrink-0 rounded-[7px]"
            />
            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
              <span className="truncate text-sm font-bold">{item.name}</span>
              <span className="truncate text-[12.5px]" style={{ color: 'var(--gs-muted)' }}>
                {item.itemsLabel} · {item.screensLabel}
              </span>
            </span>
            <span className="shrink-0 text-xs" style={{ color: 'var(--gs-muted)' }}>
              {formatRelativeTime(item.updatedAt)}
            </span>
          </Link>
        ))
      )}
    </HomeRailPanel>
  );
}
